import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";

import 'zone.js';
import { loadAsset, loadScript } from "@utils/helpers/asset-loader.helper";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

if (environment.production) { 
  enableProdMode();
}
loadAsset(`${ environment.cdn }/styles.css`);
loadAsset(
  "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
);
loadScript(
  "https://web-dev.digital.interbank.pe/ds/v2/ibk-ds/ibk-ds.esm.js",
  true
);
loadScript(
  `${ environment.iframeUrl }`
);

const hostname = window.location.hostname;
if (hostname.includes('izipay.pe')) {
  loadScript(`${ environment.cdn }/assets/js/fingerprint-no-pollyfill.js`);
} else {
  loadScript(`${ environment.cdn }/assets/js/fingerprint.js`);
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
